module.exports = __webpack_public_path__ + "img/1_02.bc75ca87.jpg";